"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fieldStyles = require("./_fieldStyles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UploadField(props) {
  return /*#__PURE__*/_react.default.createElement(_fieldStyles.FieldContainer, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, props.label), /*#__PURE__*/_react.default.createElement(_fieldStyles.Upload, {
    type: "file",
    name: props.name,
    value: props.value,
    onBlur: props.handleBlur,
    onChange: props.onChange
  }), props.error && props.touched[props.name] && /*#__PURE__*/_react.default.createElement("div", {
    className: "error"
  }, props.error));
}

UploadField.propTypes = {
  label: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.any,
  error: _propTypes.default.any,
  onChange: _propTypes.default.func.isRequired
};
UploadField.defaultValue = {};
var _default = UploadField;
exports.default = _default;